<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :readonly="disabledEdit"
                         :options="[{ type: 'alert', label: '알림 대상자 선택' }]"/>

    <!--    위험성평가 정보-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 위험성평가 정보</h5>
      </vs-col>
    </vs-row>
    <div class="grid xl:grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">공종명</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
        <ml-input v-else v-model="form.inputB_2" class="w-full flex-1" :readonly="board.readonly || disabledEdit"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업내용</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
        <ml-input v-else v-model="form.inputB_3" class="w-full flex-1" :readonly="board.readonly || disabledEdit"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">평가일</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <date-selector v-else class="w-full flex-1" v-model="form.inputB_4" :readonly="board.readonly || disabledEdit" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">실시기간</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_8 }} ~ {{ form.inputB_9 }}</p>
        <div v-else class="w-full flex-1" style="display: flex; align-items: center">
          <date-selector v-model="form.inputB_8" :readonly="board.readonly || disabledEdit" @change="checkDate(form.inputB_8)" />
          &nbsp;~&nbsp;
          <date-selector v-model="form.inputB_9" :readonly="board.readonly || disabledEdit" @change="checkDate(form.inputB_9)" />
        </div>
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">예정공정표 첨부</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputB_10.fileName }}
        </p>
        <file-uploader :readonly="board.readonly || disabledEdit" v-else v-model="form.inputB_10" class="w-full flex-1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">
          <div class="flex center-flex">
            평가마감일
            <vx-tooltip title="평가마감일이란?" :html="'총괄관리자가 평가마감일을<br>지정할 시, 지정일 이후로 문서<br>수정이 불가합니다.'"
                        style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                        position="top" delay=".1s">
              <feather-icon icon="HelpCircleIcon"
                            style="cursor: pointer; width:16px;"
              />
            </vx-tooltip>
          </div>
        </div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_11 }}</p>
        <date-selector v-else class="w-full flex-1" v-model="form.inputB_11" :readonly="board.readonly || getLevel !== 1" />
      </div>
    </div>

    <!--    위험성 평가표-->
    <table-risk-appraisal_5x4 class="mt-5" title="위험성평가표" :value="form.riskAppraisalList" @input="updateList" :isPrint="isPrint" :readonly="board.readonly || disabledEdit" :hide-code-number="true" :is-numbering="true" />

    <!-- 안전·보건관리자 검토의견 -->
    <table-risk-appraisal2_5x4 class="mt-5" title="안전·보건관리자 검토의견" v-model="form.riskAppraisalList2" :isPrint="isPrint" :readonly="board.readonly || disabledEdit" />

    <!--    사진대지-->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="readonly" section-title="조치 전 사진" placeholder="신축현장 점검" />

    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoListAfter" :is-print="isPrint" :readonly="readonly" section-title="조치 후 사진" placeholder="신축현장 점검" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly || disabledEdit"></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import PopupProjectSetting from "@/views/project/PopupProjectSetting.vue";
import MemberSelector from "@/components/selector/MemberSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import TableInspect from "@/components/TableInspect.vue";
import TableEquipment from "@/components/TableEquipment.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import TableRiskAppraisal from "@/components/TableRiskAppraisal.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import TableRiskAppraisalFIRA from "@/components/TableRiskAppraisalFIRA.vue";
import TableRiskAppraisal_5x4 from "@/components/TableRiskAppraisal_5x4/TableRiskAppraisal_5x4.vue";
import TableRiskAppraisal2_5x4 from "@/components/TableRiskAppraisal_5x4/TableRiskAppraisal2_5x4.vue";
import PhotoUploadBeforeAfterTable from "@/views/modules/PhotoUploadBeforeAfterTable.vue";

export default {
  components: {
    PhotoUploadBeforeAfterTable,
    TableRiskAppraisal2_5x4,
    TableRiskAppraisal_5x4,
    TableRiskAppraisalFIRA,
    PhotoUploadGridModule,
    TableRiskAppraisal,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    postId () {
      return this.$route.params.postId
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const proj of projects) {
          if (proj.id == this.projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            const lv = path.split("/").length - 1;
            return lv;
          }
        }
      }
    },
    disabledEdit () {
      if (this.getLevel === 1) {
        return false;
      }

      const currentDate = new Date();
      const targetDate = new Date(this.form.inputB_11);
      // 오늘 날짜와 타겟 날짜 비교
      if (targetDate < currentDate) {
        // 날짜가 같음
        if (currentDate.format('yyyy-MM-dd') === targetDate.format('yyyy-MM-dd')) {
          return false; //저장버튼보임
        }

        // 날짜가 지났음
        return true; //저장버튼숨김
      }
      // 날짜가 지나지 않았음
      else {
        return false; //저장버튼보임
      }
    },

    isPhotoListEqual () {
      if (this.form.photoList.length !== this.photoListBeforeAfter.length) {
        return false;
      }
      for (let i = 0; i < this.form.photoList.length; i++) {
        if (this.form.photoList[i] !== this.photoListBeforeAfter[i].이전사진) {
          return false;
        }
      }
      return true;
    },
    isPhotoListAfterEqual () {
      if (this.form.photoListAfter.length !== this.photoListBeforeAfter.length) {
        return false;
      }
      for (let i = 0; i < this.form.photoListAfter.length; i++) {
        if (this.form.photoListAfter[i] !== this.photoListBeforeAfter[i].이후사진) {
          return false;
        }
      }
      return true;
    },
  },
  watch: {
    "value": {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }
      },
    },
    "form": {
      important: false,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }

        this.form.summary = {
          정기위험성평가_사업장명: [],
          정기위험성평가_재해형태: [],
        };

        this.form.summary["정기위험성평가_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        for (const data of this.form.riskAppraisalList) {
          this.form.summary["정기위험성평가_재해형태"].push({
            [data.input_3]: 1,
          });
        }

        this.$emit("input", this.form);
      },
    },
    'form.inputB_11' : {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.form.inputB_11 !== '') {
          if (this.disabledEdit) {
            this.$emit("saveButtonControl", false); //저장버튼숨김
            this.$emit("removeButtonControl", false); //삭제버튼숨김
          } else {
            this.$emit("saveButtonControl", true); //저장버튼보임
            this.$emit("removeButtonControl", true); //삭제버튼보임
          }
        }
      }
    },

    // 이전 데이터방식의 데이터를 불러오기 위함
    'form.photoList' : {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.form.photoList.length > 0) {
          if (!this.isPhotoListEqual) {
            const listLength = Math.max(this.form.photoList.length, this.form.photoListAfter.length);
            this.photoListBeforeAfter = [];
            for (let i = 0; i < listLength; i++) {
              console.log('list before', i, this.form.photoList[i] ? this.form.photoList[i] : {})
              this.photoListBeforeAfter.push({
                id: `list_${i}`,
                이전사진: this.form.photoList[i] ? this.form.photoList[i] : {},
                이후사진: this.form.photoListAfter[i] ? this.form.photoListAfter[i] : {},
              });
            }
          }
        }
      }
    },
    'form.photoListAfter' : {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.form.photoListAfter.length > 0) {
          if (!this.isPhotoListAfterEqual) {
            const listLength = Math.max(this.form.photoList.length, this.form.photoListAfter.length);
            this.photoListBeforeAfter = [];
            for (let i = 0; i < listLength; i++) {
              console.log('list after', i, this.form.photoListAfter[i] ? this.form.photoListAfter[i] : {})
              this.photoListBeforeAfter.push({
                id: `list_${i}`,
                이전사진: this.form.photoList[i] ? this.form.photoList[i] : {},
                이후사진: this.form.photoListAfter[i] ? this.form.photoListAfter[i] : {},
              });
            }
          }
        }
      }
    },
  },
  data() {
    return {
      inspectionTitle: "방파제",
      photoListBeforeAfter: [],
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: {}, // file
        inputB_11: "",

        photoList: [],
        photoListAfter: [],
        fileList: [],
        riskAppraisalList: [],
        riskAppraisalList2: [],
        disasters: "",
      },
    };
  },
  methods: {
    inputPhotoList(list) {
      this.form.photoList = list.map((item) => item.이전사진);
      this.form.photoListAfter = list.map((item) => item.이후사진);
    },
    updateList(list) {
      this.form.riskAppraisalList = list;

      this.form.disasters = "";
      for (const risk of this.form.riskAppraisalList) {
        const riskName = risk.input_3.replace('직접입력_', '');
        this.form.disasters += `${riskName} `;
      }
    },
    checkDate(input) {
      if (Date.parse(this.form.inputB_8) > Date.parse(this.form.inputB_9)) {
        if (input === this.form.inputB_8) {
          this.form.inputB_9 = this.form.inputB_8;
        } else {
          this.form.inputB_8 = this.form.inputB_9;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
